import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import LinkButton from "../components/linkButton"
import Card from "../components/card"

const TrendPosts = () => {
  const data = useStaticQuery(
    graphql`
      query TrendPostsQuery {
        allMarkdownRemark(
          limit: 3
          sort: { fields: [frontmatter___date], order: DESC }
          filter: {
            frontmatter: { tags: { eq: "trend" } }
            fields: { meta: { draft: { eq: false } } }
          }
        ) {
          nodes {
            fields {
              meta {
                slug
              }
            }
            frontmatter {
              date(formatString: "YYYY.MM.DD")
              title
              description
              tags
              cover {
                childImageSharp {
                  gatsbyImageData(width: 800, formats: AUTO)
                }
              }
            }
            id
          }
        }
      }
    `
  )

  const posts = data.allMarkdownRemark.nodes

  return (
    <div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 lg:gap-7">
        {posts.map(post => (
          <Card post={post} size="m" key={`case-${post.id}`} />
        ))}
      </div>
      <div className="flex justify-center p-6 lg:p-7">
        <LinkButton text="READ MORE" url="/tag/trend/" />
      </div>
    </div>
  )
}

export default TrendPosts
